export class ArticleComponentViewModel {
    showContacts: boolean = false;
    showAboutUs: boolean = false;
    showLogo: boolean = false;
    showBody: boolean = false;
    showImage: boolean = false;
    showLinks: boolean = false;
    showDraftErrors: boolean = false;
    showPublishErrors: boolean = false;
}
